import * as Sentry from "@sentry/browser";

const sentryErrorLog = (error: unknown) => {
  Sentry.captureException(error);
};

export { sentryErrorLog };
